import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import "./students-account.css";
import * as Action from "../../store/redux/student_reducer.js";
import axios from "axios";
import { useSnackbar } from "notistack";

import { useDispatch } from "react-redux";

// importing components
import Logo from "../public_directory/public-routes-images/logos/Manga_Cons _Logo.png";
import IsLoading from "../../isLoading.jsx";
import HostelRequest from "./student-account-comps/HostelRequest.jsx";
import StudentCBTExamsLogin from "../../computer_base_assessment_components/computer_base_examination/student_components/StudentCBTExamsLogin.jsx";
// Icons import
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import SchoolIcon from "@mui/icons-material/School";

// ?_______________?
import CastForEducationOutlinedIcon from "@mui/icons-material/CastForEducationOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

// Account Comps import __________________________________________________________________________________
import Invioce from "./student-account-comps/Invoice";
import CheckResult from "./student-account-comps/CheckResult";
import CourseRegistration from "./student-account-comps/CourseRegistration.jsx";
import CourseREgForm from "./student-account-comps/CourseRegForm.jsx";
import Form02 from "./student-account-comps/Form02.jsx";
import {
  PassportUpdate,
  SignatureUpload,
} from "../public_directory/public-routs-comps/regFormComps/FileUploads.jsx";
import ExaminationCard from "../admin_directory/admin_profile_comps/student/ExaminationCard.jsx";
import StudentPrintExamsCard from "../admin_directory/admin_profile_comps/student/StudentPrintExamsCard.js";

// Variable Seperable __________________________________________________________________________________
let studentData;

export default function StudentsAccount() {
  const { adm, id } = useParams();
  const [paymentState, setPaymentState] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { info } = useSelector(
    (state) => state.studentFunction.queue.studentData,
  );

  console.log(info);

  const active = useSelector(
    (state) => state.studentFunction.dashboard?.nav_trace,
  );


  const hasPaidForSession = info?.financialRecords?.tuitionFees?.some(
  (payment) => payment.session === "2024/2025"
);

console.log(hasPaidForSession);


  // STATE MANAGEMENT HANDLING
  const dispatchStateUpdateX = async () => {
    setLoading(true);
    const studentId = adm;
    await axios
      .post(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/student_state_change`,
        { studentId },
      )
      .then((response) => {
        studentData = response.data;
        dispatch(DispatchStudentData());
        if (response?.data.status === 201) {
          enqueueSnackbar(`Success!`, {
            variant: "success",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        } else if (response?.data.status === 401) {
          enqueueSnackbar(`${response?.data.message}`, {
            variant: "error",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const DispatchStudentData = () => async (dispatch) => {
    try {
      // dispatch an action
      dispatch(Action.startStudentAction({ studentData }));
    } catch (error) {
      console.log(error);
    }
  };
  // END OF STATEMENT MANAGEMENT HANDLING

  function logOut() {
    setLoading(true);
    dispatch(DispatchLogout());
    // redirect("/management_login");
    setLoading(false);
  }
  const DispatchLogout = () => async (dispatch) => {
    try {
      dispatch(Action.logOut());
    } catch (error) {
      console.log(error);
    }
  };

  function AsideItem(props) {
    return (
      <span style={{ width: "90%" }}>
        <Link
          to={props.link}
          className={` itemsPf cb fx-ac  space1 ${
            active === `${props.hooks}` ? "active-prl-tab" : null
          }`}
          onClick={() => {
            handleNavigator(props.active);
            // setActive(`${props.active}`);
          }}
        >
          {props.icon}
          {props.img}
          <span>{props.name}</span>
        </Link>
      </span>
    );
  }

  console.log(info);
  const currentInvoice = info?.financialRecords.tuitionFees?.length;
  function switchComponents() {
    switch (active) {
      case "account":
        return "account";
      case "form02":
        return <Form02 data={info} setLoading={setLoading} />;
      case "courseReg":
        return info?.academicInfo?.courseReg ? (
          <CourseREgForm
            info={info}
            loading={loading}
            setLoading={setLoading}
          />
        ) : (
          <CourseRegistration
            info={info}
            loading={loading}
            setLoading={setLoading}
          />
        );
      case "cbt_exam":
        return (
          <StudentCBTExamsLogin
            info={info}
            loading={loading}
            setLoading={setLoading}
          />
        );
      case "restults":
        return (
          <CheckResult info={info} loading={loading} setLoading={setLoading} />
        );
      case "payment":
        return (
          <Invioce
            loading={loading}
            setLoading={setLoading}
            handlePayment={paymentState}
            SetHandlePayment={setPaymentState}
            hasPaidForSession={hasPaidForSession}

          />
        );
      case "accommodation":
        return (
          <HostelRequest
            _id={info?.admission_number || info?.academicInfo?.admission_number}
            info={info}
            loading={loading}
            studentGender={info?.personalInfo.gender}
            setLoading={setLoading}
          />
        );  
case "exam_card":
  return hasPaidForSession ? (
    <StudentPrintExamsCard
      adm={
        info?.admission_number ||
        info?.academicInfo?.admission_number
      }
      level={info?.academicInfo?.state?.level}
      semester={info?.academicInfo?.state?.current_semester}
      session={info?.academicInfo?.state?.current_session}
      setLoading={setLoading}
    />
  ) : (
  <div className="exam-payment-required">
    <div className="exam-payment-icon">
      <span>!</span>
    </div>

    <div className="exam-payment-content">
      <h3>Registration Fee Payment Required</h3>

      <p>
        You have not completed your registration fee payment for the
        current session. Your exam card cannot be generated until the
        required payment has been completed.
      </p>

      <button
        type="button"
        className="exam-payment-button"
       onClick={() => {
            handleNavigator("payment");
            // setActive(`${props.active}`);
          }}
      >
        Make Payment
        <span className="exam-payment-arrow">→</span>
      </button>
    </div>
  </div>
) 
;

      case "setting":
        return "setting";
      default:
        return info?.academicInfo.tuitionPaid ? (
          <Form02 data={info} loading={loading} setLoading={setLoading} />
        ) : (
          <Invioce info={info} loading={loading} setLoading={setLoading} />
        );
    }
  }

  // Redux functions for dashboards navigation
  function handleNavigator(item) {
    dispatch(DispatchNavigator(item));
  }
  const DispatchNavigator = (item) => async (dispatch) => {
    try {
      dispatch(Action.dispathcDashboardNavigator({ item }));
      console.log(item);
    } catch (error) {
      console.log(error);
    }
  };

  // Reupload passport component
  function ReUploadPassportCont() {
    return (
      <div
        className="noPassport fx-cl space2 fx-ac fx-jc"
        style={{
          position: "absolute",
          zIndex: "99999999",
          backgroundColor: "rgb(51 51 51 / 75%)",
          color: "#fff",
          height: "100vh",
          width: "100vw",
        }}
      >
        <div className="ReuploadsContents">
          <button onClick={() => logOut()}>logout</button>
          <h4>Passport not found</h4>

          <p style={{ textAlign: "center" }}>
            Kindly upload your passport to access the portal
          </p>

          <div className="fx-ac fx-jc space1">
            <PassportUpdate
              info={info}
              dispatchStateUpdateX={dispatchStateUpdateX}
              setLoading={setLoading}
              passport={info?.personalInfo.passport}
            />
          </div>
        </div>
      </div>
    );
  }
  // Upload Signature component
  function UploadSignature() {
    return (
      <div
        className="noPassport fx-cl space2 fx-jc fx-ac"
        style={{
          position: "absolute",
          zIndex: "99999999",
          backgroundColor: "rgb(51 51 51 / 75%)",
          color: "#fff",
          height: "100vh",
          width: "100vw",
        }}
      >
        <div className="ReuploadsContents fx-cl space2 fx-ac fx-jc">
          <h4>Signature not found</h4>

          <p style={{ textAlign: "center" }}>
            Kindly upload your signature to access the portal
          </p>

          <div className="fx-ac fx-jc space1">
            <SignatureUpload
              info={info}
              dispatchStateUpdateX={dispatchStateUpdateX}
              setLoading={setLoading}
              passport={info?.personalInfo.passport}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <section className="sectionInstructorProfile">
      {loading ? <IsLoading /> : null}
      {!info?.personalInfo.passport ? <ReUploadPassportCont /> : null}
      {info?.personalInfo.passport && !info?.personalInfo.signature ? (
        <UploadSignature />
      ) : null}
      <div className="instructorProfileCont">
        <div className="st_accontAside fx-cl fx-as space1">
          {info?.financialRecords.tuitionFees[currentInvoice - 1]
            ?.paymentStatus === "Paid" ? (
            <div className="st_accontAsideSec fs2 cwb fx-cl fx-jb ">
              <div className="fx-cl spacem">
                <div
                  className="fx-cl space2"
                  style={{ width: "100%", marginBottom: "2rem" }}
                >
                  <figure className="loginLogo fx-ac space2 fx-jc">
                    <img src={Logo} alt="logo" />
                  </figure>
                </div>
                <AsideItem
                  name="Particular form"
                  icon={<DashboardRoundedIcon fontSize="large" />}
                  hooks="form02"
                  active="form02"
                />
                <AsideItem
                  name="Course Reg."
                  icon={<PeopleAltRoundedIcon fontSize="large" />}
                  hooks="courseReg"
                  active="courseReg"
                />

                <AsideItem
                  name="Result checking"
                  icon={<AssignmentRoundedIcon fontSize="large" />}
                  hooks="restults"
                  active="restults"
                />
                <AsideItem
                  name="Invoices"
                  icon={<CategoryRoundedIcon fontSize="large" />}
                  hooks="payment"
                  active="payment"
                />
                <AsideItem
                  name="Accomodation"
                  icon={<PeopleAltRoundedIcon fontSize="large" />}
                  hooks="accommodation"
                  active="accommodation"
                />
                <AsideItem
                  name="Exam card"
                  icon={<PeopleAltRoundedIcon fontSize="large" />}
                  hooks="exam_card"
                  active="exam_card"
                />
                {/* <AsideItem
                  name="Proctor exams"
                  icon={<CategoryRoundedIcon fontSize="large" />}
                  hooks="cbt_exam"
                  active="cbt_exam"
                /> */}
              </div>

              <div className="fx-cl spacem" style={{ marginBottom: "2rem" }}>
                <figure className="prfLinksto fx-ac space2 fx-jb">
                  <span>Inventory</span>
                  <span>Edits</span>
                </figure>

                <AsideItem
                  name="My account"
                  icon={<PeopleAltRoundedIcon fontSize="large" />}
                  hooks="account"
                  active="account"
                />
                <AsideItem
                  name="Account setting"
                  icon={<PeopleAltRoundedIcon fontSize="large" />}
                  hooks="setting"
                  active="setting"
                />

                <button
                  className=" logout_st_accont fx-ac space1"
                  onClick={() => logOut()}
                >
                  <LogoutOutlinedIcon />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          ) : (
            <div className="st_accontAsideSec fs2 cwb fx-cl fx-jb ">
              <div className="fx-cl spacem">
                <div
                  className="fx-cl space2"
                  style={{ width: "100%", marginBottom: "2rem" }}
                >
                  <figure className="loginLogo fx-ac space2 fx-jc">
                    <img src={Logo} alt="logo" />
                  </figure>
                </div>

                <AsideItem
                  name="Payments invoice"
                  icon={<CategoryRoundedIcon fontSize="large" />}
                  hooks="payment"
                  active="payment"
                />
              </div>

              <div className="fx-cl spacem">
                <figure className="prfLinksto fx-ac space2 fx-jb">
                  <span>Enventory</span>
                  <span>Edits </span>
                </figure>

                <button
                  className=" logout_st_accont fx-ac space1"
                  onClick={() => logOut()}
                >
                  <LogoutOutlinedIcon />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          )}
        </div>
        <div className="st_accontHeader fx-ac fx-jb">
          <span className="fx-ac fx-jc space1">
            <span>
              <Link className="fx-ac fx-jc space1">
                <CastForEducationOutlinedIcon fontSize="large" />
                <span>Online portal</span>
              </Link>
            </span>
          </span>
          <span className="fx-ac fx-jc space3">
            <span className="notifBtn fx-ac fx-jc space1">
              <NotificationsActiveOutlinedIcon fontSize="large" />
              <figure>2</figure>
            </span>
            <span className="fx-ac fx-jc space1">
              <Link
                className="fx-ac space1"
                onClick={() => handleNavigator("account")}
              >
                <figure className="dp fx-ac">
                  <img src={info?.personalInfo.passport} alt="passport" />
                </figure>
                <p> {info?.personalInfo.first_Name} </p>
              </Link>
            </span>
          </span>
        </div>
        <div className="st_accontContents">
          <div className="switchComps">{switchComponents()}</div>
          <div className="acctRight fx-cl   space3">
            <div className="acctRgTop fx-cl space2">
              <header className="fx-jb">
                <h4>E-Learning System</h4>
                <span>...</span>
              </header>

              <div className="fx-cl">
                <div className="fx-cl">
                  <span>
                    <strong>Status:</strong> No active live lessn
                  </span>
                  <p
                    className="fs2"
                    style={{ color: "#8795A6", textTransform: "italic" }}
                  >
                    Course: not available
                  </p>
                </div>
              </div>

              <button>Join</button>
            </div>
            <div className="acctRgBottom fx-cl space1">
              <header>
                <h4>Computer Base Test</h4>
              </header>

              <div className="fx-cl ">
                <p>No current data</p>
              </div>

              <button>Start</button>

              <div className="stdAcctAction fx-jc space2">
                <button>Action</button>
                <button>Payload</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
